import React from 'react';
import {
  BOOK_ICON_PATHS,
  BOOK_ICON_STROKE_WIDTH,
} from '@/components/Icons/paths';
import type { IconComponentProps } from '@/types/components';

export const Book: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {BOOK_ICON_PATHS.map((path) => (
      <path
        key={path}
        d={path}
        stroke="currentColor"
        strokeWidth={BOOK_ICON_STROKE_WIDTH}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ))}
  </svg>
);
